import VueRouter from 'vue-router'

import DefaultLayout from './layout/default.vue'
import LoginRoutes from '../login/routes'
import RecoverRoutes from '../recover/routes'


const router = new VueRouter({
  routes: [{
    path: '/',
    component: DefaultLayout,
    children: [
      {path: '', redirect: '/login'},
      LoginRoutes,
      RecoverRoutes,

      {path: '*', redirect: (to, a, b, c) => {
        const router = this.a.methods.getRouter()
        if(router.STOP) return window.location.reload() //stop vue-router and reload page (after succesfull login!)
        return {path: 'login', query: {to: to.path}}
      }}
    ]
  }]
})



export default {
  methods: {
    //returns the router
    getRouter(){
      return router
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/routes.js